(function () {
  'use strict';

  if (window.__ANATOMY_LANDING_PAGE_INTERACTIONS__) return;
  window.__ANATOMY_LANDING_PAGE_INTERACTIONS__ = true;

  function capture(name, properties) {
    try {
      if (window.posthog && typeof window.posthog.capture === 'function') {
        window.posthog.capture(name, properties || {});
      }
    }
    catch (error) {}
  }

  function mountComparison(root) {
    if (!root || root.dataset.lpComparisonReady === 'true') return;
    var range = root.querySelector('[data-lp-before-after-range]');
    if (!range) return;

    function update() {
      var position = Math.max(0, Math.min(100, Number(range.value) || 0));
      root.style.setProperty('--lp-comparison-position', position + '%');
      range.setAttribute('aria-valuetext', Math.round(position) + '% before image');
    }

    range.addEventListener('input', update);
    update();
    root.dataset.lpComparisonReady = 'true';
  }

  function validEmail(value) {
    return /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(String(value || '').trim());
  }

  function captureProperties(form, extra) {
    return Object.assign({
      capture_id: form.getAttribute('data-an-capture-id') || '',
      capture_context: form.getAttribute('data-an-capture-context') || '',
      capture_trigger: form.getAttribute('data-an-capture-trigger') || 'inline_form',
      capture_variant: form.getAttribute('data-an-capture-variant') || 'arrow_submit',
      capture_step: 'email',
      capture_origin_path: form.getAttribute('data-an-capture-origin') || window.location.pathname
    }, extra || {});
  }

  function posthogIdentity() {
    try {
      return {
        visitorId: window.posthog && typeof window.posthog.get_distinct_id === 'function'
          ? window.posthog.get_distinct_id() || ''
          : '',
        sessionId: window.posthog && typeof window.posthog.get_session_id === 'function'
          ? window.posthog.get_session_id() || ''
          : ''
      };
    }
    catch (error) {
      return { visitorId: '', sessionId: '' };
    }
  }

  function attributionPayload() {
    try {
      var state = window.anatomyAttribution && typeof window.anatomyAttribution.getState === 'function'
        ? window.anatomyAttribution.getState()
        : {};
      var context = state.context || {};

      return {
        attribution: Object.assign({}, state.first || {}, state.last || {}),
        session: {
          entry_path: context.attribution_session_entry_path || '',
          referrer: context.attribution_session_referrer || ''
        }
      };
    }
    catch (error) {
      return { attribution: {}, session: {} };
    }
  }

  function mountEmailForm(form) {
    if (!form || form.dataset.anInlineEmailReady === 'true') return;
    var input = form.querySelector('input[type="email"]');
    var button = form.querySelector('button[type="submit"]');
    var status = form.querySelector('[data-an-inline-email-status]');
    if (!input || !button || !status) return;

    form.addEventListener('submit', function (event) {
      event.preventDefault();
      var email = input.value.trim().toLowerCase();
      if (!validEmail(email)) {
        input.setAttribute('aria-invalid', 'true');
        status.textContent = 'Enter a valid email address.';
        form.classList.add('is-error');
        return;
      }

      var identity = posthogIdentity();
      var attribution = attributionPayload();
      var context = form.getAttribute('data-an-capture-context') || 'lp_final_email';
      var source = form.getAttribute('data-an-capture-source') || 'landing_page_final';
      var workerUrl = (form.getAttribute('data-worker-url') || '').replace(/\/$/, '');
      input.removeAttribute('aria-invalid');
      form.classList.remove('is-error');
      form.setAttribute('aria-busy', 'true');
      button.disabled = true;
      status.textContent = 'Sending...';

      fetch(workerUrl + '/api/lead-capture', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({
          step: 'email',
          email: email,
          context: context,
          page_context: 'landing_page',
          source: source,
          capture_type: 'inline_email_arrow',
          page_path: window.location.pathname,
          page_url: window.location.href,
          visitor_id: identity.visitorId,
          posthog_session_id: identity.sessionId,
          attribution: attribution.attribution,
          session: attribution.session
        })
      })
        .then(function (response) {
          return response.json().catch(function () { return {}; }).then(function (data) {
            if (!response.ok || !data.success) throw new Error(data.error || 'capture_failed');
            return data;
          });
        })
        .then(function () {
          form.classList.add('is-success');
          input.disabled = true;
          status.textContent = form.getAttribute('data-success-message') || 'Check your inbox for your private protocol.';
          capture('an_email_capture_submitted', captureProperties(form, { capture_result: 'success' }));
          window.dispatchEvent(new CustomEvent('anatomy:identify-email', {
            detail: {
              email: email,
              reason: 'inline_email_capture',
              extra: captureProperties(form, { marketing_consent_source: context })
            }
          }));
        })
        .catch(function () {
          button.disabled = false;
          form.classList.add('is-error');
          status.textContent = 'Something went wrong. Please try again.';
          capture('an_email_capture_failed', captureProperties(form, { capture_result: 'error' }));
        })
        .finally(function () {
          form.removeAttribute('aria-busy');
        });
    });

    form.dataset.anInlineEmailReady = 'true';
  }

  function boot(scope) {
    var root = scope && scope.querySelectorAll ? scope : document;
    root.querySelectorAll('[data-lp-before-after]').forEach(mountComparison);
    root.querySelectorAll('[data-an-inline-email-form]').forEach(mountEmailForm);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { boot(document); });
  }
  else {
    boot(document);
  }

  document.addEventListener('shopify:section:load', function (event) {
    boot(event.target);
  });
})();
